import {ValueObject} from '@s-ui/domain'

export class SubscriptionsUserValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.email
   * @param {Object} data.subscriptions
   * */
}
